import { z } from "zod";

// TES-92 — the slice of BankID completion data that rides on the winning
// `complete` poll response, next to the JWT. `name` is BankID's canonical
// preassembled display name (ordering is theirs, not "given + surname").
//
// GDPR boundary: this is TRANSIT-ONLY. The API never persists it (the
// BankIdSession row's PII is nulled in the same write that completes the
// session, and the Patient row stores no plaintext name by design); the
// mobile app keeps it device-local in the Keychain for profile display.
export const bankIdPollUserSchema = z.object({
  name: z.string(),
  givenName: z.string(),
  surname: z.string(),
});
export type BankIdPollUser = z.infer<typeof bankIdPollUserSchema>;
